import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Manager from "../views/Manager.vue"
import Incident from "../views/Incident.vue"
import Create from "../views/Create.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/c/dashboard",
    name: "Manager",
    component: Manager,
  },
  {
    path: "/c/incident",
    name: "Incident",
    component: Incident,
  },
  {
    path: "/o/incident/create",
    name: "Create",
    component: Create,
  },
  {
    path: "/o/incident/details",
    name: "Create",
    component: Create,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
